import React, { useState, useEffect } from "react";
import "./RCBasic.css";

export default function RCBasic() {

  const [user, setUser] = useState(null);
  const [rcNumber, setRcNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser){
      setUser(storedUser);
      loadFromDB(storedUser.id);
    }
  }, []);

  // LOAD FROM DB
  const loadFromDB = async (uid) => {
    try {
      const res = await fetch(
        "https://rcfinder.online/api/get_rc_basic.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ identity: uid })
        }
      );

      const result = await res.json();
      if(result.success){
        setRecords(result.records);
      }

    } catch (e) {
      console.log("DB Fetch Failed");
    }
  };


  // SEARCH API
  const handleSearch = async () => {
    if (!rcNumber) {
      setError("Please enter RC number");
      return;
    }

    if (!user?.id) {
      setError("User identity missing");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await fetch(
        "https://rcfinder.online/api/rc_basic_fetch.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            rc_no: rcNumber,
            identity: user.id
          }),
        }
      );

      const result = await res.json();

      if (!result.success) {
        setError(result.message || "No record found");
      } else {

        if(result.wallet){
          let u = { ...user, wallet_balance: result.wallet };
          localStorage.setItem("user", JSON.stringify(u));
          setUser(u);
        }

        loadFromDB(user.id);
      }

    } catch (err) {
      setError("Something went wrong, please try again");
    }

    setLoading(false);
  };


  return (
    <div className="rc-basic-wrapper">

      <h2 className="rcbasic-title">RC BASIC SERVICE</h2>
      <div className="rcbasic-divider"></div>

<div className="top-row">
      {/* ================= SEARCH SECTION ================= */}
      <div className="search-section">
        <div className="rc-card">

          <input
            type="text"
            placeholder="Enter Vehicle Number (e.g. DL8CAF1234)"
            value={rcNumber}
            onChange={(e) => setRcNumber(e.target.value.toUpperCase())}
            className="rcbasic-input"
          />

          <button
            className="rcbasic-btn"
            onClick={handleSearch}
            disabled={loading}
          >
            {loading ? "Please Wait..." : "Search RC Basic (₹35)"}
          </button>

          {error && <p className="rcbasic-error">{error}</p>}
        </div>
      </div>



      {/* ================= INFO SECTION ================= */}
      <div className="info-section">
        <div className="rc-info-card">
          <h3>What You Will Get?</h3>

          <div className="info-grid">
            <ul>
              <li>✓ Vehicle Number</li>
              <li>✓ Owner Name</li>
              <li>✓ Father Name</li>
              <li>✓ Owner Sr No</li>
              <li>✓ Chassis Number</li>
            </ul>

            <ul>
              <li>✓ Engine Number</li>
              <li>✓ Maker & Model</li>
              <li>✓ Registration Date</li>
              <li>✓ RTO</li>
              <li>✓ Financer Details</li>
            </ul>
          </div>

        </div>
      </div>

</div>

      {/* ================= HISTORY SECTION ================= */}
      <div className="history-section">
        <div className="rc-history-card">

          <h3>RC Basic History</h3>

          <table className="history-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Vehicle</th>
                <th>Owner</th>
                <th>Father</th>
                <th>Owner Sr</th>
                <th>Chassis</th>
                <th>Engine</th>
                <th>Maker</th>
                <th>Model</th>
                <th>Reg Date</th>
                <th>RTO</th>
                <th>Financer</th>
              </tr>
            </thead>

            <tbody>

              {records.length === 0 ? (
                <tr>
                  <td colSpan="12" style={{textAlign:"center"}}>
                    No History Found
                  </td>
                </tr>
              ) : (
                records.map((row, i) => (
                  <tr key={row.id}>
                    <td>{i+1}</td>
                    <td>{row.rc_number}</td>
                    <td>{row.owner_name}</td>
                    <td>{row.father_name || "—"}</td>
                    <td>{row.owner_sr_no || "—"}</td>
                    <td>{row.chassis_no || "—"}</td>
                    <td>{row.engine_no || "—"}</td>
                    <td>{row.maker}</td>
                    <td>{row.model}</td>
                    <td>{row.reg_date}</td>
                    <td>{row.rto}</td>
                    <td>{row.financer || "—"}</td>
                  </tr>
                ))
              )}

            </tbody>
          </table>

        </div>
      </div>

    </div>
  );
}
